import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/googleMaps/useGoogleMapsQueryKeys.ts
var t = e("googleMaps", {
	search: (e) => ["search", e],
	details: (e) => ["details", e]
});
//#endregion
export { t as googleMapsQueryKeys };
